import PosScreenPage from "@icoach/pos/PosScreenPage";
import { CLUB_POS_ROUTER } from "@icoach/router/routerPath";

// POS 系統
const posRouter = [
	{
		description: "POS 系統主頁",
		exact: true,
		path: CLUB_POS_ROUTER.SCREEN,
		as: PosScreenPage,
		frontKey: "CXX99902",
	},
];

export default posRouter;
